import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
import BuildIcon from "@material-ui/icons/Build";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    console.log(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Paper className="p1">
          <div className="repo-warning">
            <BuildIcon />
            <p className="mt2 mb1">Ops! Algo se comportou como não deveria.</p>
            <p className="mb1">
              Por favor,{" "}
              <b
                className="green-alert cursor-pointer"
                onClick={() => window.location.reload(true)}
              >
                clique aqui
              </b>{" "}
              para tentarmos consertar isso.
            </p>
            <p>
              Caso continue vendo este aviso entre em contato com{" "}
              <b className="green-alert">suporte@ecorban.com.br</b>.
            </p>
          </div>
        </Paper>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/index.js